import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { DEFAULT_TIME } from "../../constants/input-entries-constants";
import { TMediaType } from "../../Types";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabat101CStore from "../../stores/khattabat-stores/101c-stores";
import getKhattabat101MatchStore from "../../stores/khattabat-stores/101m-stores";
import getKhattabatSharedMessagingStore from "../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import getKhattabatMediaStore from "../../stores/khattabat-stores/messaging-stores/conversation-media-store";

export const apiCallSendOneOOneMedia = async ({
  userID,
  conversationID,
  type,
  duration
}: {
  type: TMediaType;
  userID: number;
  conversationID: string;
  duration: number;
}): Promise<{
  data: { messageCurrentTime: string; mideaMessage: string };
  status: string;
  code: Ti18nKeys;
}> => {
  const attachment =
    getKhattabatMediaStore(conversationID).imageToBeUploadedBase64.get();
  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const userUUID =
    conversationType === "101M" || conversationType === "101M_COMMENTS"
      ? getKhattabat101MatchStore(userID).matchUUID.get()
      : getKhattabat101CStore(userID).userUUID.get();

  const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
  const { status, data, et3Error } = await post<{
    messageCurrentTime: string;
    mideaMessage: string;
  }>(`khattabat/sendOneOOneMidea`, {
    alkhattabaUUID,
    userUUID,
    userID,
    type,
    conversationType,
    attachment,
    duration
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { messageCurrentTime: DEFAULT_TIME, mideaMessage: "" },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { messageCurrentTime: DEFAULT_TIME, mideaMessage: "" },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
